// extracted by mini-css-extract-plugin
export default {"completeKycBox":"completeKyc_completeKycBox__ebrpu","completeKycBox1":"completeKyc_completeKycBox1__vh8Bw","completeKycBox2":"completeKyc_completeKycBox2__jX2ti"};